import { CarouselCardModel, CarouselDataModel, CarouselModel, PropertyTypeCarouselModel, PropertyTypeOptionModel } from 'models';
import { ResultType } from 'constants/resultType';

const PROPERTY_TYPE_CAROUSEL_INDEX = 3;
const PROPERTY_TYPE_CAROUSEL_STID_KEY = 'property-type-carousel';
const PROPERTY_TYPE_CAROUSEL_TYPE = 'PropertyTypeCarousel';

export const carouselAdapter = {
  adapt
};

function adapt(data: any): CarouselModel {
  if (data && isPropertyTypeData(data)) {
    const propertyTypeData: PropertyTypeCarouselModel = Object.assign({}, data);
    const { options, title } = propertyTypeData;
    const adaptedPropertyTypeDataModel: CarouselDataModel = {
      title,
      options: options.length && options.length > 0 ? mapPropertyTypeOptions(options) : null
    };

    return {
      index: PROPERTY_TYPE_CAROUSEL_INDEX,
      stidKey: PROPERTY_TYPE_CAROUSEL_STID_KEY,
      type: PROPERTY_TYPE_CAROUSEL_TYPE,
      model: adaptedPropertyTypeDataModel,
      resultType: ResultType.CAROUSEL
    };
  }

  return null;
}

function isPropertyTypeData(data: PropertyTypeCarouselModel): data is PropertyTypeCarouselModel {
  if ((data as PropertyTypeCarouselModel).options) {
    return true;
  }

  return false;
}

function mapPropertyTypeOptions(options: PropertyTypeOptionModel[]) {
  return options.reduce((adaptedOptions: CarouselCardModel[], option) => {
    adaptedOptions.push({
      ...option,
      actionLink: {
        url: option.linkHref,
        text: option.primaryHeading,
        linkName: `VacationRentalCarousel - ${option.primaryHeading}`,
        rfrr: `VacationRentalCarousel.${option.name}`
      },
      image: {
        url: option.imageUrl,
        description: option.primaryHeading
      },
      secondaryHeading: option.description,
      imageAttribution: null,
      regionId: null,
      description: null,
      stidKey: 'property-type-carousel'
    });

    return adaptedOptions;
  }, []);
}
